import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** FA申請種別 */
enum FaApplicationType {
  fixedAssetAcquisition = 'FA011',
  cancelFixedAssetAcquisition = 'FA012',
  fixedAssetDisposal = 'FA021',
  cancelFixedAssetDisposal = 'FA022',
  fixedAssetSales = 'FA031',
  cancelFixedAssetSales = 'FA032',
  fixedAssetTransfer = 'FA041',
  cancelFixedAssetTransfer = 'FA042',
  fixedAssetSubCategoryChange = 'FA051',
  cancelFixedAssetSubCategoryChange = 'FA052',
  cancelFixedAssetDepreciationItemChange = 'FA062',
  fixedAssetImpairmentLossEntry = 'FA071',
  cancelFixedAssetImpairmentLossEntry = 'FA072',
  fixedAssetSegmentChange = 'FA081',
  cancelFixedAssetSegmentChange = 'FA082',
  fixedAssetInformationChange = 'FA091',
  cancelFixedAssetInformationChange = 'FA092',
  fixedAssetReductionEntry = 'FA101',
  cancelFixedAssetReductionEntry = 'FA102',
  fixedAssetUnusedPeriodSetting = 'FA111',
  cancelFixedAssetUnusedPeriodSetting = 'FA112',
  fixedAssetSpecialDepreciationSetting = 'FA121',
  cancelFixedAssetSpecialDepreciationSetting = 'FA122',
  fixedAssetAdditionalDepreciationSetting = 'FA131',
  cancelFixedAssetAdditionalDepreciationSetting = 'FA132',
  fixedAssetEstimateChange = 'FA141',
  cancelFixedAssetEstimateChange = 'FA142',
  fixedAssetImpairmentAmountReversal = 'FA151',
  cancelFixedAssetImpairmentAmountReversal = 'FA152',
  fixedAssetDivision = 'FA161',
  cancelFixedAssetDivision = 'FA162',
  fixedAssetDepreciationExpensesAdjustmentEntry = 'FA171',
  cancelFixedAssetDepreciationExpensesAdjustmentEntry = 'FA172',
  fixedAssetDeclarationItemChange = 'FA181',
  cancelFixedAssetDeclarationItemChange = 'FA182',
  fixedAssetAllocationBasisSetting = 'FA191',
  cancelFixedAssetAllocationBasisSetting = 'FA192',
  aROEntry = 'FA261',
  cancelAROEntry = 'FA262',
  fixedAROEstimateChange = 'FA271',
  cancelFixedAROEstimateChange = 'FA272',
  fixedAROItemChange = 'FA281',
  cancelFixedAROItemChange = 'FA282',
}

const nameConfig = {
  fixedAssetAcquisition: new Map([
    [Locale.ja, '固定資産取得'],
    [Locale.en, 'Fixed Asset Acquisition'],
  ]),
  cancelFixedAssetAcquisition: new Map([
    [Locale.ja, '固定資産取得取消'],
    [Locale.en, 'Cancel Fixed Asset Acquisition'],
  ]),

  fixedAssetDisposal: new Map([
    [Locale.ja, '固定資産除却'],
    [Locale.en, 'Fixed Asset Disposal'],
  ]),
  cancelFixedAssetDisposal: new Map([
    [Locale.ja, '固定資産除却取消'],
    [Locale.en, 'Cancel Fixed Asset Disposal'],
  ]),
  fixedAssetSales: new Map([
    [Locale.ja, '固定資産売却'],
    [Locale.en, 'Fixed Asset Sales'],
  ]),
  cancelFixedAssetSales: new Map([
    [Locale.ja, '固定資産売却取消'],
    [Locale.en, 'Cancel Fixed Asset Sales'],
  ]),
  fixedAssetTransfer: new Map([
    [Locale.ja, '固定資産移動'],
    [Locale.en, 'Fixed Asset Transfer'],
  ]),
  cancelFixedAssetTransfer: new Map([
    [Locale.ja, '固定資産移動取消'],
    [Locale.en, 'Cancel Fixed Asset Transfer'],
  ]),
  fixedAssetSubCategoryChange: new Map([
    [Locale.ja, '固定資産分類変更'],
    [Locale.en, 'Fixed Asset Sub Category Change'],
  ]),
  cancelFixedAssetSubCategoryChange: new Map([
    [Locale.ja, '固定資産分類変更取消'],
    [Locale.en, 'Cancel Fixed Asset Sub Category Change'],
  ]),
  cancelFixedAssetDepreciationItemChange: new Map([
    [Locale.ja, '固定資産償却項目変更取消'],
    [Locale.en, 'Cancel Fixed Asset Depreciation Item Change '],
  ]),
  fixedAssetImpairmentLossEntry: new Map([
    [Locale.ja, '固定資産減損損失計上'],
    [Locale.en, 'Fixed Asset Impairment Loss Entry'],
  ]),
  cancelFixedAssetImpairmentLossEntry: new Map([
    [Locale.ja, '固定資産減損損失計上取消'],
    [Locale.en, 'Cancel Fixed Asset Impairment Loss Entry'],
  ]),
  fixedAssetSegmentChange: new Map([
    [Locale.ja, '固定資産セグメント変更'],
    [Locale.en, 'Fixed Asset Segment Change'],
  ]),
  cancelFixedAssetSegmentChange: new Map([
    [Locale.ja, '固定資産セグメント変更取消'],
    [Locale.en, 'Cancel Fixed Asset Segment Change'],
  ]),
  fixedAssetInformationChange: new Map([
    [Locale.ja, '固定資産情報変更'],
    [Locale.en, 'Fixed Asset Information Change'],
  ]),
  cancelFixedAssetInformationChange: new Map([
    [Locale.ja, '固定資産情報変更取消'],
    [Locale.en, 'Cancel Fixed Asset Information Change'],
  ]),
  fixedAssetReductionEntry: new Map([
    [Locale.ja, '固定資産圧縮記帳'],
    [Locale.en, 'Fixed Asset Reduction Entry'],
  ]),
  cancelFixedAssetReductionEntry: new Map([
    [Locale.ja, '固定資産圧縮記帳取消'],
    [Locale.en, 'Cancel Fixed Asset Reduction Entry '],
  ]),
  fixedAssetUnusedPeriodSetting: new Map([
    [Locale.ja, '固定資産遊休設定'],
    [Locale.en, 'Fixed Asset Unused Period Setting '],
  ]),
  cancelFixedAssetUnusedPeriodSetting: new Map([
    [Locale.ja, '固定資産遊休設定取消'],
    [Locale.en, 'Cancel Fixed Asset Unused Period Setting'],
  ]),
  fixedAssetSpecialDepreciationSetting: new Map([
    [Locale.ja, '固定資産特別償却設定'],
    [Locale.en, 'Fixed Asset Special Depreciation Setting'],
  ]),
  cancelFixedAssetSpecialDepreciationSetting: new Map([
    [Locale.ja, '固定資産特別償却設定取消'],
    [Locale.en, 'Cancel Fixed Asset Special Depreciation Setting'],
  ]),
  fixedAssetAdditionalDepreciationSetting: new Map([
    [Locale.ja, '固定資産増加償却設定'],
    [Locale.en, 'Fixed Asset Additional Depreciation Setting'],
  ]),
  cancelFixedAssetAdditionalDepreciationSetting: new Map([
    [Locale.ja, '固定資産増加償却設定取消'],
    [Locale.en, 'Cancel Fixed Asset Additional Depreciation Setting'],
  ]),
  fixedAssetEstimateChange: new Map([
    [Locale.ja, '固定資産見積変更'],
    [Locale.en, 'Fixed Asset Estimate Change'],
  ]),
  cancelFixedAssetEstimateChange: new Map([
    [Locale.ja, '固定資産見積変更取消'],
    [Locale.en, 'Cancel Fixed Asset Estimate Change'],
  ]),
  fixedAssetImpairmentAmountReversal: new Map([
    [Locale.ja, '固定資産減損額戻入'],
    [Locale.en, 'Fixed Asset Impairment Amount Reversal'],
  ]),
  cancelFixedAssetImpairmentAmountReversal: new Map([
    [Locale.ja, '固定資産減損額戻入取消'],
    [Locale.en, 'Cancel Fixed Asset Impairment Amount Reversal'],
  ]),
  fixedAssetDivision: new Map([
    [Locale.ja, '固定資産分割'],
    [Locale.en, 'Fixed Asset Division'],
  ]),
  cancelFixedAssetDivision: new Map([
    [Locale.ja, '固定資産分割取消'],
    [Locale.en, 'Cancel Fixed Asset Division'],
  ]),
  fixedAssetDepreciationExpensesAdjustmentEntry: new Map([
    [Locale.ja, '固定資産任意償却費計上'],
    [Locale.en, 'Fixed Asset Depreciation Expenses Adjustment Entry'],
  ]),
  cancelFixedAssetDepreciationExpensesAdjustmentEntry: new Map([
    [Locale.ja, '固定資産任意償却費計上取消'],
    [Locale.en, 'Cancel Fixed Asset Depreciation Expenses Adjustment Entry'],
  ]),
  fixedAssetDeclarationItemChange: new Map([
    [Locale.ja, '固定資産申告項目変更'],
    [Locale.en, 'Fixed Asset Declaration Item Change'],
  ]),
  cancelFixedAssetDeclarationItemChange: new Map([
    [Locale.ja, '固定資産申告項目変更取消'],
    [Locale.en, 'Cancel Fixed Asset Declaration Item Change'],
  ]),
  fixedAssetAllocationBasisSetting: new Map([
    [Locale.ja, '固定資産配賦基準設定'],
    [Locale.en, 'Fixed Asset Allocation Basis Setting'],
  ]),
  cancelFixedAssetAllocationBasisSetting: new Map([
    [Locale.ja, '固定資産配賦基準設定取消'],
    [Locale.en, 'Cancel Fixed Asset Allocation Basis Setting'],
  ]),
  aROEntry: new Map([
    [Locale.ja, '固定資産除去債務計上'],
    [Locale.en, 'ARO Entry'],
  ]),
  cancelAROEntry: new Map([
    [Locale.ja, '固定資産除去債務計上取消'],
    [Locale.en, 'Cancel ARO Entry'],
  ]),
  fixedAROEstimateChange: new Map([
    [Locale.ja, '固定資産除去債務見積変更'],
    [Locale.en, 'Fixed ARO Estimate Change'],
  ]),
  cancelFixedAROEstimateChange: new Map([
    [Locale.ja, '固定資産除去債務見積変更取消'],
    [Locale.en, 'Cancel Fixed ARO Estimate Change'],
  ]),
  fixedAROItemChange: new Map([
    [Locale.ja, '固定資産除去債務項目変更'],
    [Locale.en, 'Fixed ARO Item Change'],
  ]),
  cancelFixedAROItemChange: new Map([
    [Locale.ja, '固定資産除去債務項目変更取消'],
    [Locale.en, 'Cancel Fixed ARO Item Change'],
  ]),
};

const toEnum = rawValueToEnum(FaApplicationType, FaApplicationType.fixedAssetAcquisition);
const toDisplay = enumToName(FaApplicationType, nameConfig);
const toDisplayWithPrefix = enumToName(FaApplicationType, nameConfig, { prefix: true });

export const faApplicationType = {
  enum: FaApplicationType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { FaApplicationType };
